/// <reference path="./sdk.d.ts" />
import { Api } from "../../api"

type MercadoPagoInstance = InstanceType<Window["MercadoPago"]>

type MpResult =
  | { ok: true; mp: MercadoPagoInstance }
  | { ok: false; error: string }

let cachedInstance: MercadoPagoInstance | null = null

export async function getMpInstance(): Promise<MpResult> {
  if (cachedInstance) return { ok: true, mp: cachedInstance }

  if (!window.MercadoPago) {
    return {
      ok: false,
      error: "Falha ao carregar o Mercado Pago. Tente recarregar a página.",
    }
  }

  return new Promise(async (resolve) => {
    try {
      const keyRes = await Api.get.paymentPublicKey()
      if (!keyRes.ok) {
        resolve({ ok: false, error: keyRes.error })
        return
      }
      const mp = new window.MercadoPago(keyRes.data.publicKey, { locale: "pt-BR" })
      cachedInstance = mp
      resolve({ ok: true, mp })
    } catch {
      resolve({
        ok: false,
        error: "Falha ao carregar o Mercado Pago. Tente recarregar a página.",
      })
    }
  })
}
